import { InputDateModal } from "core/inputs/input-date/InputDateModal";
import _ from "lodash";
import { FormattedMessage } from "react-intl";
import { Typography } from "core/typography/Typography";
import { getFormattedDate } from "./functions";
import { DATATRACK_MODELS, ENTITY_TABLE_NAME } from "constants/constants";
import { format } from "date-fns";

export const getDefaulMessage = (entity) => {
  switch (entity) {
    case ENTITY_TABLE_NAME.BILLING_CLIENT:
      return {
        id: "bailly_joke_cleopatre",
        defaultMessage: "C'est trop calme... j'aime pas trop beaucoup ça",
      };
    default:
      return { id: "no_info", defaultMessage: "Aucune information à montrer" };
  }
};

export const onChange = ({
  getUpdatedValues,
  id,
  key,
  setData,
  data,
  val,
  contractualStatus,
}) => {
  const updatedData = data?.map((elm) => {
    return String(elm.id) === String(id)
      ? {
          ...elm,
          [key]: val?.[0]?.value ?? val ?? null,
          ...(contractualStatus !== undefined && {
            status: contractualStatus,
          }),
        }
      : elm;
  });
  setData(updatedData);
  getUpdatedValues(updatedData);
};

export const onChangeManager = ({
  getUpdatedValues,
  id,
  setData,
  data,
  val,
  key,
  options,
}) => {
  const selectedValue = val?.[0]?.value;
  const matchedOption = options.find((option) => option?.id === selectedValue);
  const defaultBranchId = matchedOption?.assigned_branches?.[0] ?? null;
  const updatedData = data?.map((elm) =>
    elm.id === id
      ? { ...elm, [key]: selectedValue, branch_id: defaultBranchId }
      : elm
  );
  setData(updatedData);
  getUpdatedValues(updatedData);
};

export const onChangeSubCompany = ({
  getUpdatedValues,
  id,
  setData,
  data,
  val,
  key,
}) => {
  const updatedData = data?.map((elm) =>
    elm.id === id ? { ...elm, [key]: val[0]?.value || val } : elm
  );
  setData(updatedData);
  getUpdatedValues(updatedData);
};

export const onChangeInputManager = ({
  getUpdatedValues,
  id,
  setData,
  data,
}) => {
  const updatedData = data?.map((elm) =>
    elm.id === id ? { ...elm, manager_id: null } : elm
  );
  setData(updatedData);
  getUpdatedValues(updatedData);
};

export const onChangeInputSubCompany = ({
  getUpdatedValues,
  id,
  setData,
  data,
}) => {
  const updatedData = data?.map((elm) =>
    elm.id === id ? { ...elm, subcontractor_company_id: null } : elm
  );
  setData(updatedData);
  getUpdatedValues(updatedData);
};

export const onDelete = ({ id, data, setData, getUpdatedValues }) => {
  const updatedData = data.filter((elm) => elm.id !== id);
  setData(updatedData);
  getUpdatedValues(updatedData);
};

export const onAdd = ({ header, data, setData, type = null }) => {
  const newId = _.uniqueId();
  const keys = ["id", ...header.map((elm) => elm.label.key)];
  const newData = keys.reduce(
    (prev, curr) => ({
      ...prev,
      [curr]:
        curr === "id" && type !== DATATRACK_MODELS.CONTRACT ? newId : null,
    }),
    { newRow: true }
  );
  setData([newData, ...data]);
};

export const renderCommonBlock = ({
  data,
  getUpdatedValues,
  id,
  onDelete: deleteData,
  setData,
  updated_at,
  updated_by,
  lang,
  setElementsToDelete,
  deleteError,
  errorToDisplay,
  readOnly,
  deleteBtnTestId,
}) => ({
  updated_by,
  updated_at: (
    <div className="space-between">
      <div>{getFormattedDate(updated_at, lang)}</div>
      {!readOnly && (
        <button
          data-testid={deleteBtnTestId}
          style={{
            marginLeft: "1rem",
          }}
          onClick={() => {
            if (deleteError) {
              errorToDisplay();
            } else {
              setElementsToDelete((prevElementsToDelete) => [
                ...prevElementsToDelete,
                data.find((elm) => elm.id === id),
              ]);
              deleteData({ id, setData, data, getUpdatedValues });
            }
          }}
        >
          <Typography
            className="link-2 violet "
            type="h2"
            label={<FormattedMessage id="delete" defaultMessage="Supprimer" />}
          />
        </button>
      )}
    </div>
  ),
});

export const renderStartDateEndDate = ({
  data,
  getUpdatedValues,
  id,
  start_date,
  end_date,
  setData,
  onChangeDates,
  lang,
  modalType,
  dataTestIndex,
}) => ({
  start_date: (
    <div data-testid={`${modalType}_modal-start_date-${dataTestIndex}`}>
      <InputDateModal
        lang={lang}
        elm={{ id, start_date }}
        onChange={(date) => {
          const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
          onChangeDates({
            getUpdatedValues,
            id: id,
            key: "start_date",
            setData,
            data,
            val: formattedDate,
          });
        }}
      />
    </div>
  ),
  end_date: (
    <div data-testid={`${modalType}_modal-end_date-${dataTestIndex}`}>
      <InputDateModal
        lang={lang}
        elm={{ id, end_date }}
        onChange={(date) => {
          const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
          onChangeDates({
            getUpdatedValues,
            id: id,
            key: "end_date",
            setData,
            data,
            val: formattedDate,
          });
        }}
      />
    </div>
  ),
});

//add lineId to keys
export const transformObject = (inputObject) => {
  const id = inputObject.id;
  const transformedObject = _.mapKeys(inputObject, (value, key) => {
    if (key !== "id") {
      return `${key}_${id}`;
    }
    return key;
  });
  return transformedObject;
};
